import React, { Component } from 'react';
import commonUtil from '../../utils/commonUtil';
import { connect } from 'react-redux';
import EventIconWithLoader from '../EventIcon/EventIconWithLoader';
import { searchSvgIcon, calenderIcon } from '../NewHeader/Header/svgIcons';

class EventTemplate extends Component {

  componentDidUpdate() {
    if(this.props.onActiveThemeColorUpdate){
      const { selectedTheme } = this.props;
      const color500 = selectedTheme?.color_500 ?? '#333333';
      this.props.onActiveThemeColorUpdate(color500);
    }
  }

  render() {

    const { selectedTheme, selectedImage1, selectedImage2, eventTxtValue, eventDateValue, icon, ownerName, coOwnerName, celebrityName, lables, txtEventComment } = this.props;

    let bgImage = selectedTheme?.banner_texture?.url ?? '';
    let bgUrlCardHeader = selectedImage2 ? selectedImage2 : bgImage;
    bgUrlCardHeader = bgUrlCardHeader ? bgUrlCardHeader : commonUtil.getAssetURL() + '/images/pattern/Elegancia.png';

    const color50 = selectedTheme?.color_50 ?? '#f2f2f2';
    const color200 = selectedTheme?.color_200 ?? '#A1A1A1';
    const color300 = selectedTheme?.color_300 ?? '#A1A1A1';
    const color500 = selectedTheme?.color_500 ?? '#333333';
    const color700 = selectedTheme?.color_700 ?? '#151515';

    let formattedDate = "";
    if (eventDateValue && typeof eventDateValue === "string" && eventDateValue.includes("-")) {
        const [year, month, day] = eventDateValue.split("-");
        if (year && month && day) {
            formattedDate = `${day}/${month}/${year}`;
        }
    } else if (eventDateValue && typeof eventDateValue === "string" && eventDateValue.includes("/")) {
      formattedDate = eventDateValue;
    }

    return (
      <div className="row">
        <div className="col-xs-12 col-md-10 col-md-offset-1 col-lg-10 col-lg-offset-1">
          <div className="event-customization">
            <div className="event-card" style={{ backgroundColor: color500 }}>
              <div className="card-header">
                <div
                  className={`event-header-image ${selectedImage2 ? 'removeOpacity' : ''}`}
                  style={{ backgroundImage: `url(${bgUrlCardHeader})`}}
                ></div>
                <div className="icon-btn icon-left">
                  <span className="icon-settings"></span>
                </div>
                <div className="icon-btn icon-right">
                  <span className="icon-notification"></span>
                </div>
                {/* <div className={!isDefaultImage ? "event-logo" : "event-logo-2"}>
                  <img src={eventLogo} className={selectedImage1 ? "event-logo-alignment event-logo-img" : (!isDefaultImage ? "event-logo-alignment" : "event-logo-alignment-2")} alt="Event Logo" style={{ color: color300 }} />
                </div> */}
                <div className="event-logo">
                  <EventIconWithLoader  
                    event_id='demo'
                    event_icon={icon}
                    event_theme_color={color500}
                    event_image={selectedImage1?.trim() !== '' && selectedImage1}
                    icon_width={'70.213px'}
                    icon_height={'70.213px'}
                  />
                </div>
              </div>

              <div className="card-body">
                <div className="event-name">{eventTxtValue ? eventTxtValue : 'Boda en leon'}</div>
                <div className="event-txt event-calender-txt">
                  <i>{calenderIcon}</i> <span>{formattedDate ? formattedDate : '30/12/2023'}</span>
                </div>
                <div className="event-comment">{txtEventComment}</div>
                <div className="event-owner">
                  {/* <i className="iconRight icon-flecha_lightsvg_derecha"></i> */}
                  {/* <img className="iconRight" src={commonUtil.getAssetURL() + '/images/right.svg'} alt="Icon Right" /> */}
                  <div>{ownerName ? ownerName : ""}</div>
                  <div>{coOwnerName ? coOwnerName : ""}</div>
                  <div>{celebrityName ? celebrityName : ""}</div>
                </div>
                <div className="event-txt">
                  <span>{commonUtil.getLabel(lables.createEventStep2, 'createEventStep2.nombreEvent.label') || 'Número del evento:'}</span>
                  <span>{this.props.eventId ? this.props.eventId : '00000000'}</span>
                </div>
              </div>
              <div>
                <img className="right-icon-create-event" src="/assets/web/images/right_arrow_create-event.svg" alt="" />
              </div>
            </div>

            <div className="event-details-section">
              <div className="row">
                <div className="container_button_vozcliente_createvent">
                  <button className="button_vozcliente" onClick={this.vozCliente}>
                    <div className="container-image container-image_createvent">
                      <img src={commonUtil.getAssetURL() + '/images/vozCliente.svg'} alt="Logo Voz del Cliente" className="icon_vozcliente icon_vozcliente_createvent" />
                    </div>
                  </button>
                </div>
                <div className="col-xs-12">
                  <div className="event-search_input">
                    <form className="event-search-form">
                      <div className="event-search-form_control">
                        <input
                          id="eventSearch"
                          autoComplete="off"
                          type="text"
                          placeholder="¿Buscas la mesa de alguien más? Encuéntrala aquí"
                        />
                        <span className="icon-zoom-svg" > {searchSvgIcon}</span>
                      </div>
                    </form>
                  </div>
                </div>
              </div>


              <ul id="tabs" className="nav nav-tabs event-nav" style={{ color: color700 }}>
                <li className="null "><a id="tabgiftList" className="" href="#giftList" style={{ borderBottomColor: color700 }}>{commonUtil.getLabel(lables.createEventStep2, 'createEventStep2.miLista.label')}</a></li>
                <li className="null active"><a id="tabRegisteredGifts" className="selected" href="#RegisteredGifts"  
                  ref={(el) => {
                    if (el) el.setAttribute('style', `border-bottom: 0.585px solid ${color700} !important`);
                  }}
                > {commonUtil.getLabel(lables.createEventStep2, 'createEventStep2.misRegalos.label')}</a></li>
                <li className="null"><a id="tabEventPurchases" className="" href="#EventPurchases" style={{ borderBottomColor: color700 }}>{commonUtil.getLabel(lables.createEventStep2, 'createEventStep2.misCompras.label')}</a></li>
                <li className="null"><a id="tabTableSummary" className="" href="#TableSummary" style={{ borderBottomColor: color700 }}>{commonUtil.getLabel(lables.createEventStep2, 'createEventStep2.resumen.label')}</a></li>
              </ul>

              <div className="tab-content">
                <div className="tab-pane" id="giftList">
                  <div className="event-title" style={{ backgroundColor: color50, color: color700 }}>
                    {commonUtil.getLabel(lables.createEventStep2, 'createEventStep2.listaRegalos.label')}
                  </div>
                </div>
                <div className="tab-pane active" id="RegisteredGifts">
                  <div className="event-title" style={{ backgroundColor: color50, color: color700 }}>
                    {commonUtil.getLabel(lables.createEventStep2, 'createEventStep2.misReglos.label')}
                  </div>
                  <div className="event-giftList">
                   {/* <div className="row">
                      <div className="col-xs-5">
                        <span className="event-giftList-search pull-right">
                          Buscar artículo
                        </span>
                      </div>
                      <div className="col-xs-3">
                        <span className=""></span>
                      </div>
                      <div className="col-xs-3">
                        <span className=""></span>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-xs-4">
                       <span className="event-giftList-filter">
                          <span className=""></span>Filter
                        </span>
                      </div>
                      <div className="col-xs-8">
                       <span className=""></span> Ordenar: Mayor a menor precio
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-xs-12">
                        Seleccionar todo
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-xs-12">
                        <div>
                          <span>4 de 4 </span>productos
                        </div>
                        <div>
                          <div class="media">
                            <div class="media-left">
                              <img class="media-object" src="..." alt="..." />
                            </div>
                            <div class="media-body">
                              <div>Crema clinique 250gr</div>
                              <div>$ 100</div>
                              <div>Cantidad: 1</div>
                              <div>Nombre largo del</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}
                  </div>

                </div>
                <div className="tab-pane" id="EventPurchases">
                  <div className="event-title" style={{ backgroundColor: color50, color: color700 }}>
                    {commonUtil.getLabel(lables.createEventStep2, 'createEventStep2.misCompras.label')}
                  </div>
                </div>
                <div className="tab-pane" id="TableSummary">
                  <div className="event-title" style={{ backgroundColor: color50, color: color700 }}>
                  {commonUtil.getLabel(lables.createEventStep2, 'createEventStep2.resumen.label')}
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { selectedImage1, selectedImage2, eventTxtValue, eventDateValue } = state?.createEvent ?? {};
  
  return {
    selectedImage1,
    selectedImage2,
    eventTxtValue,
    eventDateValue,
  };
};

export default connect(mapStateToProps)(EventTemplate);